<template>
    <div>
        <div class="alert alert-success">{{ status }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            status: {
                type: String,
                required: true,
            },
        },
    };
</script>
